// @mui
import { Card } from '@mui/material';
// types
import { ReportTemplateContainer } from 'src/types/report-template';
// api
import { ReportRowDto, ReportColumnDto } from 'src/api';
// components
import { ReportTable } from 'src/components/report/report-table';
// columns
import { ColumnTemplates } from 'src/components/report/column';

type props = {
  table: ReportTemplateContainer;
  rows: ReportRowDto[];
  columns: ReportColumnDto[];
  index: number;
  dataSource?: string[];
};

export default function ReportEditTableElement({ table, rows, columns, index, dataSource }: props) {
  return (
    <Card>
      <ReportTable
        rows={rows}
        columns={ColumnTemplates()
          .map((c) => ({
            ...c,
            index: columns.find((x) => x.field === c.field)?.index ?? c.index,
            width: columns.find((x) => x.field === c.field)?.width ?? c.width,
          }))
          .sort((a, b) => (a.index ?? 0) - (b.index ?? 0))}
        table={table}
        index={index}
      />
    </Card>
  );
}
